function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendKnockout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0h24ZM3.443 11.133h7.194c.52 0 .867.347.867.867s-.347.867-.867.867H3.443l-1.994 6.5c-.346.954 0 2.081.78 2.774.781.693 1.907.78 2.861.347l16.208-8.148c.867-.433 1.474-1.3 1.474-2.34 0-.953-.52-1.907-1.474-2.34C17.051 7.58 9.51 3.766 5.003 1.512c-.953-.433-2.08-.346-2.86.347-.78.693-1.127 1.733-.78 2.774l2.08 6.5Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendKnockout);
export default __webpack_public_path__ + "static/media/send_knockout.f3e1b3906a6e7a4cb99e126ed29b5a5f.svg";
export { ForwardRef as ReactComponent };